<template>
  <div class="calendar text-center py-3">
    <v-toolbar color="#E21A22" dark>
      <v-btn icon @click="$refs.calendar.prev()">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title>{{ currentMonth }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$refs.calendar.next()">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-toolbar>
    <v-row>
      <v-col>
        <v-btn color="primary" @click="getYear" :loading="loading"
          >Print Routes</v-btn
        >
        <div class="mt-3 font-weight-medium">{{ pickupNotice }}</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-sheet height="800">
          <v-calendar
            ref="calendar"
            v-model="today"
            :events="events"
            :event-color="getEventColor"
            type="month"
            :weekdays="weekdays"
            @change="getEvents"
          ></v-calendar>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "Calendar",
  data: () => ({
    events: [],
    year_events: [],
    today: "",
    weekdays: [1, 2, 3, 4, 5],
    currentMonth: "",
    loading: false,
    pickupNotice:
      "Pick up dates may change due to holidays or route adjustments.",
    logo: "",
    customer_logo: "",
    customer_logo_width: 0,
    customer_logo_height: 0
  }),
  computed: {},
  watch: {
    today: function() {
      this.currentMonth = this.$moment(this.today).format("MMMM, YYYY");
    }
  },
  methods: {
    getEventColor: function(event) {
      return event.color;
    },
    addHeaderFooter: function(doc) {
      let este = this;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      // Header
      doc.text("12401 Woodruff Ave. Unit 10, Downey, CA 90241", 15, 29);
      doc.setFont("helvetica", "bold");
      doc.text(este.pickupNotice, 15, 34);
      doc.addImage(este.logo, "PNG", 15, 5, 46, 20);
      if (este.customer_logo != "") {
        doc.addImage(
          este.customer_logo,
          "PNG",
          150,
          5,
          este.customer_logo_width,
          este.customer_logo_height
        );
      }
    },
    getYear: function() {
      var este = this;
      este.loading = true;
      este.$http
        .post(este.$api + "year-routes", {
          customer_id: este.$store.getters.customer_id,
          token: este.$store.getters.token,
          date: este.today
        })
        .then(function(response) {
          if (response.status == 200 && response.data.status == "ok") {
            // Load 2 js libraries
            // 1. jsPDF
            // 2. jsPDF-AutoTable
            este.logo = response.data.logo;
            este.customer_logo = response.data.customer_logo;
            este.customer_logo_width = response.data.customer_logo_width;
            este.customer_logo_height = response.data.customer_logo_height;
            const { jsPDF } = window.jspdf;
            const doc = new jsPDF();
            let data = response.data.data;

            // Generate table
            doc.autoTable({
              head: [["Clinic", "Date of Service", "Location"]],
              body: data,
              startY: 39, // Start position below header
              styles: { fontSize: 10 },
              margin: { top: 39, bottom: 20 },
              didDrawPage: function() {
                este.addHeaderFooter(doc);
              }
            });
            let totalPages = doc.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
              doc.setPage(i);
              let pageHeight = doc.internal.pageSize.height;
              doc.setFont("helvetica", "normal");
              doc.setFontSize(10);
              doc.text(
                `Page ${i} of ${totalPages}`,
                doc.internal.pageSize.width - 30,
                pageHeight - 10
              );
            }

            // Save the PDF
            doc.save("Service_Schedule.pdf");
          } else {
            var mensaje = {
              color: "red",
              timeout: 5000,
              message: response.data.msg
            };
            este.manifests = [];
            este.$store.commit("msgMuestra", mensaje);
            if ("error" in response.data && response.data.error == "logout") {
              este.$router.push("/logout");
            }
          }
          este.loading = false;
        })
        .catch(function(err) {
          este.year_events = [];
          var mensaje = {
            color: "red",
            timeout: 5000,
            message: "There was an error. Please try again."
          };
          este.$store.commit("msgMuestra", mensaje);
          este.loading = false;
          window.console.log(err);
        });
      console.log("Year Events");
      console.log(this.today);
      // this.$refs.calendar.updateTimes();
    },
    getEvents: function() {
      var este = this;
      este.$http
        .post(este.$api + "routes", {
          customer_id: este.$store.getters.customer_id,
          token: este.$store.getters.token,
          date: este.today
        })
        .then(function(response) {
          if (response.status == 200 && response.data.status == "ok") {
            console.log("IMPRIME DATOS");
            window.console.log(response.status);
            este.events = response.data.data;
            console.log(este.events);
          } else {
            var mensaje = {
              color: "red",
              timeout: 5000,
              message: response.data.msg
            };
            este.manifests = [];
            este.$store.commit("msgMuestra", mensaje);
            if ("error" in response.data && response.data.error == "logout") {
              este.$router.push("/logout");
            }
          }
        })
        .catch(function(err) {
          este.manifests = [];
          var mensaje = {
            color: "red",
            timeout: 5000,
            message: "There was an error. Please try again."
          };
          este.$store.commit("msgMuestra", mensaje);
          window.console.log(err);
        });
      console.log("New Events");
      console.log(this.today);
      this.$refs.calendar.updateTimes();
    }
  },
  mounted: function() {
    let este = this;
    this.today = this.$moment().format("YYYY-MM-DD");
    //this.currentMonth = this.$moment().format("MMMM, YYYY");
    this.$store.commit("title", "Pick Up Calendar");
    setTimeout(() => {
      este.getEvents();
    }, 1000);
  }
};
</script>
